// src/Modal.tsx
import React, { FC, ReactNode } from 'react';
import { cn } from './card';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  alignment?: string;
  roundness?: string;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, children, alignment = 'items-center', roundness = 'rounded-2xl' }) => {
  if (!isOpen) return null;

  return (
    <div className={cn(`fixed inset-0 flex justify-center z-50`, alignment)}>
      <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
      <div className={cn(`bg-white dark:bg-neutral-600 shadow-xl z-50 animate-modalShow`, roundness)}>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
